import React from "react";
import Container from "react-bootstrap/Container";
import styles from "./privacy.module.css";

const PrivacyPolicy = () => (
  <Container className={styles.term}>
    <br />
    <h1 className="center">Privacy Policy </h1>
    <br />

    <div>
      <p>
        Carbae, accessible via our website (
        <a href="https://www.carbae.in" target="_blank" rel="noreferrer">
          www.carbae.in
        </a>
        ),mobile application (available on Google Play and App Store or any
        other platforms), and any other digital interfaces or services we may
        provide (collectively referred to as the "Platform"), is committed to
        protecting your privacy. This Privacy Policy outlines the types of
        personal and non-personal information we collect and explains how we
        collect, use, store, process, transfer, share, and safeguard your
        information when you access, browse, book, buy, or use any of our
        products or services through any of these platforms.
      </p>
    </div>

    <h2>Consent</h2>
    <div className={styles.font}>
      <p>
        By accessing or using our Platform — including our website, mobile
        application, or any other digital service — you acknowledge that you
        have read, understood, and agreed to the terms of this Privacy Policy
        and consent to the collection, use, and processing of your information
        as described herein.
      </p>
    </div>

    <h2>Acknowledgment:</h2>
    <div className={styles.font}>
      <p>
        PLEASE READ THIS PRIVACY POLICY CAREFULLY. YOU INDICATE THAT YOU
        UNDERSTAND, AGREE AND CONSENT TO THIS PRIVACY POLICY. HENCE BY VISITING
        OUR PLATFORM OR BY USING / AVAILING ANY OF OUR SERVICE OR PRODUCT, YOU
        HEREBY GIVE YOUR UNCONDITIONAL CONSENT OR AGREEMENT TO AUTOBAE
        TECHNOLOGIES PRIVATE LIMITED AS PROVIDED UNDER SECTION 43A AND SECTION
        72A OF INDIAN INFORMATION TECHNOLOGY ACT, 2000 FOR COLLECTION, USE,
        STORAGE, PROCESSING, SHARING AND TRANSFER AND DISCLOSURE OF YOUR
        INFORMATION.
      </p>
      <p>
        YOU ACKNOWLEDGE THAT YOU HAVE ALL LEGAL RIGHTS AND LAWFUL AUTHORITY TO
        SHARE THE INFORMATION WITH US AND FURTHER ACKNOWLEDGE THAT BY
        COLLECTING, SHARING, PROCESSING AND TRANSFERRING INFORMATION PROVIDED BY
        YOU, SHALL NOT CAUSE ANY LOSS OR WRONFUL GAIN TO YOU OR ANY OTHER
        PERSON.
      </p>
      <p>
        IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, PLEASE DO NOT
        ACCESS / USE OUR PLATFORM OR AVAIL ANY OF OUR SERVICE OR PRODUCT ON OUR
        PLATFORM.
      </p>
    </div>

    <p>This policy is designed to make you understand:</p>
    <ol className={styles.list}>
      <li>
        The type of information which You share with Us or which We collect
        during Your usage of our Platform or availing any Product or Services
        from Our Platform
      </li>
      <li>
        The purpose of collection, storage, processing and transferring of Your
        Information by Us.
      </li>
      <li>
        Security measures implemented by Us to protect Your Information as
        mandated by law.
      </li>
      <li>
        Disclosure, sharing and transfer of Your personal information by Us and
        purpose of such disclosure, sharing or transfer
      </li>
    </ol>

    <h2>Information We Collect (Your Information):</h2>
    <p>
      We collect Your information during Your usage of Platform or when You
      avail any of products or services available on or through Platform, either
      as a registered user or otherwise when you visit any of our other website
      pages or mobile applications.
    </p>
    <p>The information collected may consist of:</p>
    <ol>
      <li>Your Personal Information:</li>
      <br />
      <p>
        Your full name, age, address, email id, phone number, date of birth,
        gender, financial information, any other sensitive personal data or
        information etc. We collect Your Personal Information when You create an
        account at Our Platform or fill out a form or respond to a survey.
      </p>
      <li>Your Non-Personal information: </li>
      <br />
      <p>
        a) Usage : How You use Our Platform, such as the types of content that
        you view or engage with, the features You use, Your searches & results,
        Your browsing information, the actions You take and the time, frequency
        and duration of your activities.
      </p>
      <p>
        b) Device Information: Information about the computer, mobile, laptop,
        tablet or any other internet enabled electronic device (”Device”) You
        use to access the Platform. This may include real-time information about
        the geographic location of Your Device as permitted by You, internet
        connection, Your IP address, operating systems, platforms, browsing
        information, Device type, Device ID, network information, metadata and
        other information associated with other files stored on Your Device,
        last URL visited, your website search history.
      </p>
      <p>
        c) Preference: Your preferences and setting such as geographical
        location, time zone and language.
      </p>
      <p>
        d) Information from third parties: We may collect, process and store
        Your user ID associated with any social media account (such as your
        Facebook and Google account) that You use to sign into the Platform or
        connect with or use with the products or services. When You sign in to
        Your account with Your social media account information, or otherwise
        connect to Your social media account with the Product or Services, You
        consent to Our collection, storage, and use, in accordance with this
        Privacy Policy, of the information that You make available to Us through
        the social media interface. This could include, without limitation, any
        information that You have made public through Your social media account,
        information that the social media service shares with Us, or information
        that is disclosed during the sign-in process. Please see Your social
        media provider's privacy policy and help center for more information
        about how they share information when You choose to connect Your
        account.
      </p>
      <p>
        e) Vehicle Information : Vehicle Registration Details, Vehicle
        Manufacturer, Vehicle Model, Vehicle Color, Vehicle Transmission,
        Vehicle Engine Size, Vehicle Sample Image, Vehicle Insurance, Odometer
        reading of the vehicle, Number of previous owners, Physical condition of
        vehicle and accident history, Financing of vehicle including any Linked
        Loan and/ or other Lien, Details of involvement of vehicle in court/
        investigation proceedings and any and all other information in respect
        of the identity and the condition of the vehicle.
      </p>
      <p>
        We may also obtain information about You from third parties such as
        partners, marketers, third-party websites and researchers and combine
        that information with information which We collect from or about You.
      </p>
      <p>
        We may use third-party service providers to serve ads on CarBae’s behalf
        across the internet and sometimes on the Platform. They may collect
        information about Your visits to the Platform, and Your interaction with
        the products and services on the Platform.
      </p>
      <p>
        f) Cookies and other Electronic Tools: We may use cookies, pixel tags,
        web beacons, mobile device IDs and similar files or technologies to
        collect and store information in respect to Your use of the Platform1.
        You can erase or choose to disable/block these cookies through Your
        Device/browser settings. You can configure Your browser to alert You
        when we attempt to send You a cookie with an option to accept or refuse
        the cookie. If You have turned cookies off, You may be prevented from
        using certain features of the Platform and this may interfere with
        certain functionality of the Platform.
      </p>
    </ol>

    <h2>Purpose of Collection, Storage, Processing of Your Information:</h2>
    <p>
      CarBae collect Your Information solely for the purpose of providing you
      the products or services that is connected with the function or activity
      of the CarBae which includes but not limited to the following (“Purpose”):
    </p>
    <ul>
      <li>
        To inform You about various products and services offered on Our
        Platform and provide customer support to You.
      </li>
      <li>
        To address Your queries and resolve your concerns pertaining to any
        product or service that You were looking for.
      </li>
      <li>
        To send You survey and marketing communications or facilitate various
        programmes and initiatives launched either by Us or third party which We
        believe may be of interest to You.
      </li>
      <li>
        To facilitate Your usage of Platform (what features You like, how You
        use the, etc.) and improve Our products or services, or any other
        content on the Platform (such as by personalizing content to your
        interests), process and complete your transactions, and make special
        offers
      </li>
      <li>
        To review Platform performance, diagnose technical problems and do data
        analysis to make Your experience better.
      </li>
      <li>To protect the integrity of Our Platform</li>
      <li>
        To inform You about change in any term and condition of this Privacy
        Policy or Terms of Use of any Platform of CarBae
      </li>
      <li>
        To implement information security practices, to determine any security
        breaches, contaminant or computer virus, to investigate/prevent/take
        action against illegal activities and suspected fraud.
      </li>
      <li>
        To keep You informed about news, events and ideas regarding Your
        preferences and help You to improve Your knowledge and skills about the
        preferred content.
      </li>
      <li>
        To carry out Our obligations and enforce Our rights arising from any
        contracts entered into between You and Us.
      </li>
      <li>
        To allow You to participate in interactive features offered through Our
        Platform.
      </li>
      <li>
        To contact You about Our own and third-party products and services that
        may be of interest to You. If You do not want Us to use Your Information
        in this way, please check the relevant box located on the form on which
        We collect Your data and/or adjust Your user preferences in Your account
        profile.
      </li>
      <li>
        To produce and share aggregate insights and statistics that do not
        identify You.
      </li>
      <li>
        To enable Us independently or in association with third party to show
        You tailored ads that are relevant to You.
      </li>
      <li>
        To enable Us to display advertisements to our advertisers'/service
        providers' target audiences. Even though We do not disclose Your
        Personal Information for these purposes without Your consent, if You
        click on or otherwise interact with an advertisement, the advertiser may
        assume that You meet its target criteria.
      </li>
      <li>
        To help advertisers and other partners measure the effectiveness and
        distribution of their ads and services, and understand the types of
        people who use their services and how people interact with their
        websites, apps and services.
      </li>
      <li>
        In any other way We may describe when You provide the Information.
      </li>
      <li>For any other purpose with Your consent</li>
    </ul>

    <h2>Sharing, Transfer or Disclosure of Your Information:</h2>
    <ol>
      <li>
        Any service or product provided through Our Platform may be provided
        either by CarBae or its vendor, dealer, OEM, channel partners and other
        third parties (“Other Entities”) which are registered with CarBae to
        render the services or provide products through Platform or otherwise.
        You acknowledge and agree that CarBae may share, disclose, transfer or
        part with Your Information to Other Entities depending upon the type of
        Product or Service You are looking for or for one or more of the
        permissible purposes. CarBae may also share Your Personal or
        Non-Personal information where it is required to share the same with
        such Other Entities for providing you the product or service and You
        provide CarBae Your unconditional consent to do the same.
      </li>
      <li>
        CarBae may share statistical data and/or other Non-personal Information
        or details to facilitate various program or initiatives launched by
        CarBae, third party service providers, partners or financial
        institutions, from time to time.
      </li>
      <li>
        We use other third parties such as a credit/debit card processing
        company, payment gateway, pre-paid cards etc. to enable You to make
        payments for buying products or availing services on Platform. When You
        sign up for these services, You may have the ability to save Your card
        details for future reference and faster future payments. In such case,
        We may share Your relevant Information as necessary for the third
        parties to provide such services, including your name, residence and
        email address. The processing of payments or authorization is solely in
        accordance with these third parties policies, terms and conditions and
        we are not in any manner responsible or liable to You or any third party
        for any delay or failure at their end in processing the payments.
      </li>
      <li>
        In addition to this, CarBae reserve the right to share Your Information
        with any Government Agency or other authorized law enforcement agencies
        (LEAs) mandated under law to obtain Your Information for the purpose of
        verification of identity or for prevention, detection, investigation
        including but not limited to cyber incidents, prosecution, and
        punishment of offences etc.
      </li>
      <li>
        We may process Your Information outside India ad relay on legally
        provided mechanisms to lawfully transfer Your Information across
        borders.
      </li>
      <li>
        We may share Your Information in any other circumstances where We have
        Your consent.
      </li>
    </ol>

    <h2>Communication</h2>
    <p>
      We may contact You through email, mobile phone, notices posted on Our
      Platform and other ways including but not limited to text messages and
      push notifications. We may send You messages or emails about the
      availability of Our products and services, notifications, promotional
      messages, security, or other service-related issues. You may change Your
      communication preferences at any time.
    </p>

    <h2>Manner of storage of Your Information</h2>
    <p>
      Your Information will mostly be stored in electronic form however certain
      data may be stored in physical form. We may store, collect, use and
      process Your Information within Republic of India and/or outside India
      subject to compliance under applicable laws. We may enter into agreements
      with third parties (in or outside of India) to store or process Your
      Information and such third parties may have their own security measures to
      safeguard Your Information which security standards as comparable with
      good industry practices.
    </p>

    <h2>Third Party Links:</h2>
    <p>
      It is clarified that while Your usage to Our Platform, You might see the
      links to the third party website / advertisements / electronic
      communication service, which are provided by the third parties. As the
      operation of the third party is not under control Carbae, therefore Carbae
      does not make any endorsement / guarantee of any service or product
      offered through third party websites nor make any representation related
      to the any privacy policy or other policies of such third party. Any usage
      of such third party website or availing any service or product through
      third party shall be at Your risk and Carbae is not responsible for any
      loss / damage or otherwise. It is recommended that You should review the
      privacy policy of such third party websites prior to using such websites
    </p>

    <h2>Additional Privacy Information for Mobile App Users</h2>
    <p>
      This section provides specific details regarding data collection,
      permissions, and usage within the Carbae mobile application, in compliance
      with the Google Play policies and user privacy standards
    </p>

    <ol>
      <li>
        <h3> Information We Collect via the Mobile App</h3>
        <p>
          In addition to the information already covered in this privacy policy,
          when you use our mobile application, we may collect the following
          types of data:
        </p>
        <ul>
          <li>
            <b> Location Data:</b> With your permission, we collect and use your
            device’s precise or approximate location to:
            <ul>
              <li>
                Show you relevant car offers and services available nearby.
              </li>
              <li>Route leads to the nearest showroom efficiently.</li>
            </ul>
          </li>
        </ul>
        <p>
          We do not collect location data unless you grant permission, and you
          can disable it at any time via your device settings.
        </p>
      </li>
      <li>
        <h3>Mobile App Permissions</h3>
        <p>
          Our app may request access to the following permissions, depending on
          the features you use
        </p>
        <ul>
          <li>
            <b> Location: </b> Used to personalize services, identify nearby
            dealerships, and improve lead routing accuracy.
          </li>
          <li>
            <b> Camera </b> (planned feature): May be used in the future to
            enable uploading of documents or capturing images, such as for car
            scans or identity verification.
          </li>
          <li>
            <b> Storage/Media </b> (planned feature): May be used in the future
            to allow users to upload or save files, documents, or images as part
            of the service process.
          </li>
          <li>
            <b> Contacts </b> (planned feature): May be used in the future to
            enable features like referral sharing or pre-filling forms using
            your contact information, with your permission.
          </li>
          <li>
            <b> Phone State </b> (planned feature): May be used in the future to
            detect call activity, such as pausing in-app media when a call comes
            in, to enhance user experience.
          </li>
          <li>
            <b>SMS Access </b> (planned feature): May be used in the future for
            OTP auto-fill functionality, strictly with your consent and only for
            verification purposes.
          </li>
        </ul>
        <b> Note: </b> We currently do not use all of the permissions listed
        above. If and when we introduce new features requiring these
        permissions, they will be requested through the app and will require
        your explicit consent before activation.
      </li>
      <br></br>
      <li>
        <h3>Use of Third-Party Services & SDKs</h3>
        <p>
          Our mobile app may use third-party services (such as analytics or
          crash reporting tools) to enhance performance and user experience.
          These may include:
        </p>
        <ul>
          <li>Google Analytics for Firebase</li>
          <li>Crashlytics</li>
          <li>Payment gateways (e.g., Razorpay)</li>
          <li>Push notification services ( e.g., Firebase)</li>
        </ul>
        <p>
          These services may collect anonymized data about app usage, device
          info, and performance. We ensure all third-party partners comply with
          relevant privacy and data protection laws.
        </p>
      </li>
      <li>
        <h3> Data Retention</h3>
        <p>
          We retain personal and device-related data only for as long as
          necessary to:
        </p>
        <ul>
          <li>Provide our services.</li>
          <li>Fulfill legal and regulatory obligations.</li>
          <li>Improve user experience.</li>
        </ul>
        <p>
          You may request deletion of your data at any time by contacting us.
        </p>
      </li>
      <li>
        <h3>Your Rights and Controls</h3>
        <p>As a user, you have the right to:</p>
        <ul>
          <li>Revoke app permissions via your device settings.</li>
          <li>Request access to or deletion of your data.</li>
          <li>Opt out of promotional communications.</li>
          <li>
            Contact our support for clarification regarding any data collection.
          </li>
        </ul>
      </li>
    </ol>

    <div>
      <h2>Security Measures:</h2>
      <p>
        Carbae takes utmost care to secure Your Information from unauthorised
        access, usage or disclosure or alteration. We take appropriate steps and
        security measures to safeguard Your Information and make sure that Your
        Information is secured as mandated by law. For this purpose we adopt
        reasonable security practices and procedures, in line with the industry
        standard, to include, technical, operational, managerial and physical
        security controls in order to protect your personal information from
        unauthorized access, or disclosure while it is under our control.
      </p>
      <p>
        While We protect Your Personal information as per industry standards,
        You acknowledge that the internet or computer networks are not fully
        secure and that We cannot provide any absolute assurance regarding the
        security of Your Personal information. Therefore You acknowledge that
        You shall not hold responsible Carbae in any manner whatsoever for loss
        of Your Information, or any other data, which You shares with Us or
        which We have with Us if such loss or any damage caused to You because
        of Force Majeure events. You further acknowledge that any information
        (including your personal information) transmitted to Us or from Your use
        of Platform will therefore be at Your own risk.
      </p>
      <p>
        It is clarified that Force Majeure events includes any event which is
        beyond the reasonable control of the Carbae which may include but not
        limited to sabotage, fire, flood, explosion, acts of God, civil
        commotion, strikes or industrial action of any kind, riots,
        insurrection, war, acts of government, computer hacking, unauthorized
        access to computer, computer system or computer network, computer
        crashes, breach of security and encryption.
      </p>
    </div>

    <div>
      <h2>Your Choices to Control Your Personal Information</h2>
      <ul>
        <li>
          <b> Change or Correct:</b> We take all endeavors to update Our records
          with latest information as provided by You, however if you see any
          discrepancy in Your Personal Information, You may edit some of Your
          Personal Information or contact Us through Our Data Protection
          Officer/Grievance Officer to have Your Information updated with Us
        </li>
        <li>
          <b>Object to, or Limit or Restrict, Use: </b> You can ask Us to stop
          using or to limit Our use (in partial or full) Your Personal
          Information (past, existing or future).
        </li>
        <li>
          <b> Deletion:</b> You can ask Us to erase or delete (in partial or
          full) Your Personal Information (past, existing or future).{" "}
        </li>
        <li>
          <b> Right to Access:</b> You can ask Us for a copy of Your Personal
          Information.
        </li>
        <li>
          <b> Account Closure:</b> If You choose to close Your Account, We will
          delete your Personal Information or de-identify it so that it is
          anonymous and not attributed to your identity. We will retain your
          Personal Information after You have closed Your account if reasonably
          necessary to comply with Our legal obligations (including law
          enforcement requests), meet regulatory requirements, resolve disputes,
          maintain security, prevent fraud and abuse, enforce Our User
          Agreement, or fulfill Your request to “unsubscribe” from further
          messages from Us. We will retain de-personalized information after
          your account has been closed.
        </li>
        <li>
          <b> Withdraw Consent/Opt-out: </b>At any time, you can withdraw
          consent that You have provided to Us by going to your account
          settings, if you have an account with us or otherwise you may request
          for Withdrawing your consent by writing an email to us at
          contact@carbae.in. We will only collect and process Personal
          Information about You where We have lawful bases. Lawful bases include
          consent (where You have given consent), contract (where processing is
          necessary for the performance of a contract with You (e.g. to deliver
          products or services you have requested)) and “legitimate interests”.
          Where We rely on Your consent to process Personal Information, you
          have the right to withdraw or decline Your consent at any time and
          where we rely on legitimate interests, you have the right to object.
        </li>
      </ul>
      <p>
        You may also contact Us using the contact information below, and We will
        consider Your request in accordance with applicable laws.
      </p>
      <p>
        Residents in the Designated Countries may have additional rights under
        their laws.
      </p>
      <p>
        ‘Designated Countries’ refers to countries in the European Union (EU),
        European Economic Area (EEA) and Switzerland.
      </p>
    </div>
    <div>
      <h2>Authorization:</h2>
      <p>
        You also acknowledge that all the information provided by You are out of
        Your free will and in compliance with applicable laws in Your territory.
        If We found that any of Your Information is in non-compliance with the
        terms and conditions and Privacy policy, Carbae reserves the right to
        remove your non-compliant information from its systems. Further,
        depending on the seriousness of the non-compliance, We may choose to
        discontinue some or all of the services being provided to You by Us.
      </p>
      <p>
        In purview of the Telecom Regulatory Authority of India (TRAI)
        guidelines, You hereby authorize Carbae and its affiliates/partners or
        otherwise who are accessing the Your Information by virtue of their
        association with Carbae to communicate with You through
        telephone/mobile, Email, SMS or other modes of communication (now
        available or may be available in future) even if Your number/numbers(s)
        is/are registered in the National Do Not Call Registry (NDNC) or
        www.nccptrai.gov.in
      </p>
    </div>

    <div>
      <h2>European Union (EU) privacy/data protection rights</h2>
      <p>
        EU General Data Protection Regulation (GDPR) has provided the below
        rights to the EU residents:
      </p>
      <ul>
        <li>
          Right to information - including contact details to the DPO, the
          purposes for processing Personal Information and the rights of the
          individual.
        </li>
        <li>Right to access the Personal Information that are processed.</li>
        <li>Right to erasure (”Right to be forgotten”).</li>
        <li>Right to rectification.</li>
        <li>Right to restriction of processing.</li>
        <li>
          Right to data portability of the Personal Information supplied to Us
          by the EU resident.
        </li>
        <li>
          Right to object (opt-out) to processing (unless otherwise We have
          compelling legitimate grounds).
        </li>
      </ul>
      <p>
        EU residents can exercise these rights by raising a request directly at
        contact@carbae.in or contact us at the information provided in CONTACT
        US section with specific requirements
      </p>
    </div>

    <h2>Change in terms of Privacy Policy:</h2>
    <p>
      Carbae reserves the right to amend or modify this Privacy Policy at any
      time, as and when the need arises. We request you to regularly check this
      Privacy Policy from time to time to keep you apprise of changes made. Your
      continued use of the Platform gives your unconditional acceptance to such
      change in terms of Privacy Policy.
    </p>
    <p>
      Particulars of corporate entity, Data Protection Officer/Grievance Officer
      pursuant to the provisions of Companies Act, 2013 and The Indian
      Information Technology Act, 2000 and rules made and applicable laws
      thereunder
    </p>
    <p>
      If you have any concern related to this Privacy Policy or collection,
      storage, retention or disclosure of Your Information under the terms of
      this Privacy Policy or Terms of Use or any other terms and conditions of
      Carbae or its other business entities including any queries or grievances,
      You can contact to Carbae through its Data Protection Officer/Grievance
      Redressal Officer at the below given details:
    </p>
    <p>
      E-mail :{" "}
      <a href="mailto:contact@carbae.in" className="text_secondary">
        contact@carbae.in
      </a>
    </p>
  </Container>
);
export default PrivacyPolicy;
